module.exports = __webpack_public_path__ + "assets/img/main_background_work.3e0cc64a.jpg";